import store from "@frameworks/web/redux/store";
import { PORTFOLIO_COMPOSITION, PORTFOLIO_COMPOSITION_ERROR, PORTFOLIO_COMPOSITION_HIDE_ERROR, PORTFOLIO_COMPOSITION_START_LOADER, PORTFOLIO_COMPOSITION_STOP_LOADER, } from "../interface/IPortfolioComposition";
class PortfolioCompositionActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getPortfolio(data) {
        this.dispatch({
            type: PORTFOLIO_COMPOSITION,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: PORTFOLIO_COMPOSITION_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: PORTFOLIO_COMPOSITION_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: PORTFOLIO_COMPOSITION_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: PORTFOLIO_COMPOSITION_STOP_LOADER,
        });
    }
}
export default PortfolioCompositionActions;
